module.exports = __webpack_public_path__ + "img/chris_giga_zp.932ce6c9.jpg";